import * as React from 'react';
export var FieldMode;
(function (FieldMode) {
    FieldMode[FieldMode["NONE"] = 0] = "NONE";
    FieldMode[FieldMode["SEARCH"] = 1] = "SEARCH";
    FieldMode[FieldMode["POPULATE"] = 2] = "POPULATE";
    FieldMode[FieldMode["DEFAULT"] = 3] = "DEFAULT";
    FieldMode[FieldMode["PRESERVE"] = 4] = "PRESERVE";
    FieldMode[FieldMode["COUNTRY"] = 8] = "COUNTRY";
})(FieldMode || (FieldMode = {}));
// See Loqate docs here: https://www.loqate.com/resources/support/setup-guides/advanced-setup-guide/
const API_KEY = 'XW86-UR92-ME93-TP16';
const CSS_URL = 'https://services.postcodeanywhere.co.uk/css/address-3.91.css';
const JS_URL = 'https://services.postcodeanywhere.co.uk/js/address-3.91.js';
export function useLoqate(params) {
    const refLink = React.useRef();
    const refScript = React.useRef();
    const [loaded, setLoaded] = React.useState(false);
    const [control, setControl] = React.useState();
    const paramsSerialized = JSON.stringify(params);
    React.useEffect(() => {
        if (loaded) {
            return;
        }
        if (window.pca) {
            setLoaded(true);
            return;
        }
        if (!refLink.current) {
            const link = document.createElement('link');
            link.href = CSS_URL;
            link.rel = 'stylesheet';
            link.type = 'text/css';
            document.head.appendChild(link);
            refLink.current = link;
        }
        if (!refScript.current) {
            const script = document.createElement('script');
            script.src = JS_URL;
            script.onload = function onload() {
                setLoaded(true);
            };
            document.head.appendChild(script);
            refScript.current = script;
            const subScript = document.createElement('script');
            subScript.src = JS_URL;
            subScript.textContent = `pca.on("options", function(type, key, options) {
        options.suppressAutocomplete = false;
      });`;
            document.head.appendChild(subScript);
        }
    }, []);
    React.useEffect(() => {
        if (!loaded) {
            return;
        }
        // Create new instance of address capture.
        const control = new window.pca.Address(params.fields, {
            ...params.options,
            key: API_KEY,
        });
        // Run additional setup for hook usage.
        params.init(control);
        // Store control in state.
        setControl(control);
        // Ensure control is removed and events unbound if unmounted
        return () => {
            control.destroy();
        };
    }, [loaded, paramsSerialized]);
    return control;
}
